import { CalendarAfsService } from '@/services/calendar-afs.service'
export default {
  methods: {
    canCreate() {
      return this.dataPermission.includes('CNPS_CALENDAR_AFS_INSERT')
    },
    canExport() {
      return this.dataPermission.includes('CNPS_CALENDAR_AFS_LIST_ON_WEB')
    },
    canDetail() {
      return this.dataPermission.includes('CNPS_CALENDAR_AFS_DETAIL')
    },
    canEdit(status) {
      return (
        this.dataPermission.includes('CNPS_CALENDAR_AFS_UPDATE') &&
        ['NEW', 'PROCESSING'].includes(status)
      )
    },
    canCoppy(purposes, isMcUploadPhoto) {
      return purposes?.includes('ADD_MC_PHOTOS') && isMcUploadPhoto === false
    },
    canUpdate(status) {
      return (
        this.dataPermission.includes('CNPS_CALENDAR_AFS_EVALUTE') &&
        ['NEW', 'PROCESSING'].includes(status)
      )
    },
    canCancel(status) {
      return this.dataPermission.includes('CNPS_CALENDAR_AFS_CANCEL') && status === 'NEW'
    },
    canCancelBonus(status) {
      return this.dataPermission.includes('CNPS_CALENDAR_AFS_CANCEL') && status === 'PROCESSING'
    },
    async calendarCancelBonus(item) {
      if (item.handlerRes.userName === this.userData.username) {
        const flag = await this.approveMx('Bạn Có Chắc Chắn Muốn Hủy Công Việc trên Không?')
        if (flag === true) {
          this.submitCancel(item.id)
        }
      } else {
        this.showFailMx('Bạn không có quyền thực hiện thao tác này')
      }
    },
    // hủy
    async calendarCancel(item) {
      if (
        item.creatorInfo.userName === this.userData.username ||
        item.handlerRes.userName === this.userData.username
      ) {
        const flag = await this.approveMx('Bạn Có Chắc Chắn Muốn Hủy Công Việc trên Không?')
        if (flag === true) {
          this.submitCancel(item.id)
        }
      } else {
        this.showFailMx('Bạn không có quyền thực hiện thao tác này')
      }
    },
    async submitCancel(id) {
      try {
        this.showLoading = true
        const response = await CalendarAfsService.cancelCalendarAFS({ id })
        if (response.success) {
          this.showSuccessMx(response.message)
          this.fetchData()
        }
        if (response.code !== 1000) {
          this.showFailMx(response.message)
        }
      } catch (error) {
      } finally {
        this.showLoading = false
      }
    },

    showTimeEstimate(data) {
      return data.startIntend && data.endIntend
    },
    showTimeProcessing(data) {
      return data.startProcessing && data.endProcessing
    },
    showTimeUpdate(data) {
      return data.dateEdit
    },
    showIsMcUploadedPhoto(purposes, isMcUploadPhoto) {
      return purposes?.includes('ADD_MC_PHOTOS') && isMcUploadPhoto === true
    },
  },
  async onChangeType(value) {
    if (value === 'MC_INACTIVE') {
      return [
        'MC tạm ngưng/ngưng hoạt động',
        'MC thay đổi thông tin người đại diện/địa chỉ/email/SĐT/tài khoản nhận tiền/ngành nghề kinh doanh',
        'MC không biết cách sử dụng sản phẩm',
        'MC chưa hiểu lợi ích của dịch vụ trả góp',
        'MC không tồn tại',
        'MC mượn địa chỉ cửa hàng khác để đăng ký tài khoản MPOS',
        'Thao tác/sử dụng phức tạp',
        'Thiết bị lỗi/hỏng',
        'Mất thiết bị',
        'Phí quẹt thẻ cao/sợ mất phí',
        'Yêu cầu cung cấp chứng từ rườm rà',
        'Thời gian thanh toán chậm',
        'Khách không có thói quen dùng thẻ',
        'Khách không có thẻ tín dụng',
        'MC đã chuyển dùng giải pháp khác (vnpay, payoo...)',
        'MC vẫn đang hoạt động bth (sử dụng tid/ mid khác)',
        'Sử dụng pos khác (chỉ dùng mpos trả góp)',
        'KH Chuyển khoản/ Tiền mặt',
        'Vắng khách',
        'Thời tiết',
        'Khác (ghi rõ lý do)',
      ]
    }
    if (value === 'MC_DECREASE_TPV') {
      return [
        'MC tạm ngưng/ngưng hoạt động',
        'MC không biết cách sử dụng sản phẩm',
        'MC chưa hiểu lợi ích của dịch vụ trả góp',
        'Thao tác/sử dụng phức tạp',
        'Thiết bị lỗi/hỏng',
        'Mất thiết bị',
        'Phí quẹt thẻ cao/sợ mất phí',
        'Yêu cầu cung cấp chứng từ rườm rà',
        'Thời gian thanh toán chậm',
        'Khách không có thói quen dùng thẻ',
        'Khách không có thẻ tín dụng',
        'MC đã chuyển dùng giải pháp khác (vnpay, payoo...)',
        'MC vẫn đang hoạt động bth (sử dụng tid/ mid khác)',
        'Sử dụng pos khác (chỉ dùng mpos trả góp)',
        'KH Chuyển khoản/ Tiền mặt',
        'Vắng khách',
        'Không có nhân viên mPOS hỗ trợ sau khi mua thiết bị',
        'Khác (ghi rõ lý do)',
      ]
    }
    return []
  },
}
